import React from 'react';
import { connect } from 'react-redux';
import './signin.scss';
import {
  FormField,
  Input,
  InputLabel,
  SectionBody,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import warning from '../../static/images/mvp/warning.png';
import { CustomSelectComponent, formTheme } from './ThemeSignIn';
import { I18n } from '../../helpers/i18n';

const SENIOR = 'explorer';
const BUDDY = 'guide';
const BOTH = 'both';

class SignUpUnifiedForm extends React.Component {
  constructor(props) {
    super(props);
    this.inputs = {};
    this.state = {};

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type ? checked : value;
    this.inputs['checkedValue'] = check_type ? value : null;
    this.props.onInputChange(evt);
  }

  handleSelectCommunity = (data) => {
    this.props.onSelectCommunity(data);
  };

  render() {
    const {
      errorEmail,
      errorName,
      errorPassword,
      errorRePassword,
      errorGiftCode,
      errorYouthCommunity,
      youthCommunity,
      listBuddyYouthCommunity,
      email,
      rePassword,
      password,
      name,
      giftCode,
      type
    } = this.props;
    
    const theme = {
      color: '#000000',
      fontSize: '16px',
      lineHeight: '24px',
      borderColor: '#CCCCCC',
      borderRadius: '4px',
      padding: '14px 16px',
    };

    // Determine which fields to show based on type
    // TODO: All roles should show this field
    const showYouthCommunity = true;
    const showGiftCode = type === SENIOR || type === BOTH;

    // Only the _id returned by list-youth-community may reach the sign-up APIs
    const youthCommunityOptions = (Array.isArray(listBuddyYouthCommunity) ? listBuddyYouthCommunity : [])
      .filter((option) => option && option._id)
      .map((option) => ({ ...option, value: option._id }));
    

    return (
      <SectionBody theme={formTheme}>
        {/* Email Field - Always shown */}
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('senior_account_account_info_email_label')} <span className="text-danger">*</span></InputLabel>
          <Input
            autoFocus
            placeholder={I18n.t('email_hint_text')}
            key="email"
            name="email"
            value={email}
            onChange={this.handleInputChange}
            theme={{ input: { ...theme, borderColor: errorEmail ? '#FF445D' : '#cccccc' } }}
          />
          {errorEmail && (
            <span className="error-message">
              <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorEmail}
            </span>
          )}
        </FormField>

        {/* Full Name Field - Always shown */}
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('name_hint_text')} <span className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('name_hint_text')}
            key="name"
            name="name"
            value={name}
            onChange={this.handleInputChange}
            theme={{ input: { ...theme, borderColor: errorName ? '#FF445D' : '#cccccc' } }}
          />
          {errorName && (
            <span className="error-message">
              <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorName}
            </span>
          )}
        </FormField>

        {/* Password Field - Always shown */}
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('password')} <span className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('password_hint')}
            key="password"
            name="password"
            type="password"
            value={password}
            onChange={this.handleInputChange}
            theme={{ input: { ...theme, borderColor: errorPassword ? '#FF445D' : '#cccccc' } }}
            autoComplete="off"
          />
          {errorPassword && (
            <span className="error-message">
              <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorPassword}
            </span>
          )}
        </FormField>

        {/* Confirm Password Field - Always shown */}
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('confirm_password_title')} <span className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('confirm_password_hint')}
            key="rePassword"
            name="rePassword"
            type="password"
            value={rePassword}
            onChange={this.handleInputChange}
            autoComplete="off"
            theme={{ input: { ...theme, borderColor: errorRePassword ? '#FF445D' : '#cccccc' } }}
          />
          {errorRePassword && (
            <span className="error-message">
              <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorRePassword}
            </span>
          )}
        </FormField>

        {/* Youth Community Field - Conditional */}
        {showYouthCommunity && (
          <FormField theme={formTheme}>
            <InputLabel theme={formTheme}>{I18n.t('youth_community_question')} <span className="text-danger">*</span></InputLabel>
            <CustomSelectComponent
              placeholder={I18n.t('select_youth_community')}
              required
              isSearchable
              options={youthCommunityOptions}
              selectedValue={youthCommunity}
              onChange={(e) => this.handleSelectCommunity(e.target.value)}
            />
            {showYouthCommunity && errorYouthCommunity && (
              <div className="error-message" style={{ marginTop: '10px' }}>
                <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                {errorYouthCommunity}
              </div>
            )}
          </FormField>
        )}
        

        {/* Gift Code Field - Conditional */}
        {showGiftCode && (
          <FormField theme={formTheme}>
            <InputLabel theme={formTheme}>{I18n.t('gift_code')}</InputLabel>
            <Input
              placeholder={I18n.t('gift_code')}
              key="giftCode"
              name="giftCode"
              value={giftCode}
              onChange={this.handleInputChange}
              autoComplete="off"
              theme={{ input: { ...theme, borderColor: errorGiftCode ? '#FF445D' : '#cccccc' } }}
            />
            {errorGiftCode && (
              <span className="error-message">
                <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                {errorGiftCode}
              </span>
            )}
          </FormField>
        )}
      </SectionBody>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  userInfo: user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpUnifiedForm);
